
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brochure-request/form",
      function () {
        return require("private-next-pages/brochure-request/form/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brochure-request/form"])
      });
    }
  